/*
 * @Description:
 * @Date: 2022-12-01 10:50:49
 */
import {
  batchDownloadReceipt,
  exportTerminalPayListUrl,
  terminalquerySelectList
} from '@/views/industry-terminal-pay/src/data-source/apis';
import {
  BaseButton,
  useDatePickerColumn,
  useInputColumn,
  useSelectColumn,
  XrkTableProps
} from 'xrk-components';
import { date } from 'xrk-tools';
import { dealParam, state } from './use-event';
import { formatter } from '@/utils';
const resetBtn = {
  show: true,
  text: '重置',
  beforeReset: searchValue => {
    state?.tableRenderRef.value?.setSearchValue?.('dateArr', defaultDates);
    return {
      ...searchValue,
      dateArr: defaultDates
    };
  }
};
const defaultDates = [
  date.dateFormat(new Date().getTime() - 1000 * 60 * 60 * 24 * 30, 'Y-M-D'),
  date.dateFormat(new Date(), 'Y-M-D')
];
const payDt = useDatePickerColumn({
  prop: 'dateArr',
  label: '支付时间',
  defaultValue: defaultDates,
  config: {
    type: 'daterange',
    startPlaceholder: '开始时间',
    endPlaceholder: '结束时间'
  }
});

const projectName = useSelectColumn({
  prop: 'projectId',
  label: '项目名称',
  config: {
    clearable: true,
    placeholder: '请输入关键字',
    filterUseRemote: true,
    remoteMethod: async (val: string) => {
      const data = await terminalquerySelectList({
        type: 1,
        keyword: val || ''
      });
      return data;
    },
    labelKey: 'projectName',
    valueKey: 'projectId'
  }
});
const enterpriseName = useSelectColumn({
  prop: 'csoEntId',
  label: '服务商企业',
  config: {
    clearable: true,
    placeholder: '请输入关键字',
    filterUseRemote: true,
    remoteMethod: async (val: string) => {
      const data = await terminalquerySelectList({
        type: 2,
        keyword: val || ''
      });
      return data;
    },
    labelKey: 'csoEntName',
    valueKey: 'csoEntId'
  }
});

const functionCode = useSelectColumn({
  prop: 'functionCode',
  label: '付款方',
  config: {
    options: [
      { label: '服务商', value: 2 },
      { label: '供应商', value: 3 }
    ]
  }
});

const otherComponents = [
  {
    render({ searchValue }) {
      return (
        <BaseButton
          v-resource={[['下载回单']]}
          type="primary2"
          click={async () => {
            const queryParam = JSON.stringify(
              dealParam({
                downloadType: state.active.value === 1 ? 1 : 3,
                ...searchValue
              })
            );
            const fileName = `电子回单_${formatter.date(
              Date.now(),
              'YYYYMMDD'
            )}`;
            await batchDownloadReceipt({
              fileName: decodeURIComponent(fileName),
              downloadType: 801,
              queryParam
            });
          }}
        >
          批量下载回单
        </BaseButton>
      );
    }
  },
  {
    render({ searchValue }) {
      return (
        <BaseButton
          v-resource={[['导出']]}
          type="primary2"
          click={async () => {
            await exportTerminalPayListUrl(dealParam(searchValue as any));
          }}
        >
          导出
        </BaseButton>
      );
    }
  }
];

export const projectSearchConfig: XrkTableProps['searchConfig'] = {
  searchColumns: [projectName, enterpriseName, payDt, functionCode],
  otherComponents,
  resetBtn
};

export const personSearchConfig: XrkTableProps['searchConfig'] = {
  searchColumns: [
    projectName,
    useInputColumn({
      prop: 'fullName',
      label: '项目参与人',
      config: {
        clearable: true,
        placeholder: '请输入项目参与人'
      }
    }),
    useInputColumn({
      prop: 'phone',
      label: '手机号',
      config: {
        type: 'tel',
        clearable: true,
        placeholder: '请输入关键字'
      }
    }),
    enterpriseName,
    payDt,
    functionCode
  ],
  otherComponents,
  resetBtn
};
